<template>
    <div class="canvas-stage">
        <div class="mission" :style="{background: cover_background}">
            <div class="container">
                <div class="text" :style="editor_styles">
                    <in-place-html-editor v-if="$page.props.canvas_editable"
                                          v-model="cover.text" @change="coverTextUpdated"/>
                    <div v-else>{{ cover.text }}</div>
                </div>
                <sleek-file-uploader v-if="$page.props.canvas_editable"
                                     class="image"
                                     @change="coverImageUploaded">
                    <i class="cvico-picture-o icon"></i>
                    Click Here to Upload Your Photo
                </sleek-file-uploader>
            </div>
        </div>
        <div class="journey" :style="{backgroundColor: stage.config.color}">

            <canvas-top-curve class="stage-top-curve" :color="stage.config.color">
                <div class="icon">
                    <img :src="stage.slug === 'intro' ? `/images/icons/new/icon-warmup.svg` : `/images/icons/new/icon-${stage.slug}.svg`" alt="">
                </div>
            </canvas-top-curve>

            <div class="container">
                <h2 class="heading">Our Journey {{ stage.config.name }}</h2>

                <div class="deliverable" :style="`background-image: ${deliverable_background}`">
                    <div class="deliverable-text"
                         :style="{backgroundColor: utils.colorBrightness2(stage.config.color, -10)}">
                        <in-place-html-editor v-if="$page.props.canvas_editable"
                                              class="text-area"
                                              v-model="deliverable.text"
                                              @change="setCanvasDeliverable({stage, text: $event})"
                                              placeholder="Describe your experience"/>
                        <div v-else>{{ deliverable.text }}</div>
                    </div>
                    <sleek-file-uploader v-if="$page.props.canvas_editable"
                                         class="deliverable-image"
                                         @change="setCanvasDeliverable({stage, file: $event})">
                        <i class="cvico-picture-o icon"></i>
                        <div class="label">Click here to upload deliverable</div>
                    </sleek-file-uploader>
                </div>

                <draggable v-if="$page.props.canvas_editable"
                           class="journey-cards"
                           v-model="canvas_uploads"
                           item-key="id"
                           @sort="changed(stage)">
                    <template #item="{element}">
                        <div class="item" :class="`w-${element?.options?.width ?? 1}`">
                            <journey-card :editable="true" :upload="element"/>
                        </div>
                    </template>
                </draggable>
                <div v-else
                     class="journey-cards">
                    <div class="item" v-for="element in canvas_uploads"
                         :class="`w-${element?.options?.width ?? 1}`">
                        <journey-card :upload="element"/>
                    </div>
                </div>
<!--                <div v-for="upload in getAllCanvasActivityUploadsByStage(stage.slug)" :key="upload.id"-->
<!--                     :class="i === 2 ? 'w-2': (i === 6 ? 'w-3' : 'w-1')"-->
<!--                     class="item">-->
<!--                    <pre>{{ upload }}</pre>-->
<!--                    <journey-card :file="upload.file"/>-->
<!--                </div>-->
                <div class="actions" v-if="$page.props.canvas_editable">
                    <div class="action-row">
                        <div class="action-col">
                            <color-button :color="stage.config.color" @click="goToActivities">
                                <template #icon>
                                    <i class="cvico-arrow-up"></i>
                                </template>
                                <span class="text-uppercase text-nowrap btn-text">Return to Activities</span>
                            </color-button>
                        </div>
                        <div class="action-col">

                            <file-uploader-modal v-if="upload.show"
                                                 :stage="stage"
                                                 v-model="upload.data"
                                                 @close="hideUpload()"
                                                 @change="uploaded"/>

                            <color-button :color="stage.config.color" @click="showUpload()">
                                <template #icon>
                                    <i class="cvico-arrow-up"></i>
                                </template>
                                <span class="text-uppercase text-nowrap btn-text">Upload your Work</span>
                            </color-button>
                        </div>
                        <div class="action-col">
<!--                            {{ {published_canvas_stages, stage_is_published, slug: stage.slug} }}-->
                            <color-button v-if="stage_is_published"
                                          :color="stage.config.color"
                                          @click="unPublish()">
                                <template #icon>
                                    <i class="cvico-arrow-up"></i>
                                </template>
                                <span class="text-uppercase text-nowrap btn-text">Un-Publish your Canvas</span>
                            </color-button>
                            <color-button v-else
                                          :color="stage.config.color"
                                          @click="publish()">
                                <template #icon>
                                    <i class="cvico-arrow-up"></i>
                                </template>
                                <span class="text-uppercase text-nowrap btn-text">Publish your Canvas</span>
                            </color-button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <publish-canvas-modal v-if="publish_modal.enabled"
                              :stage="stage"
                              @close="closePublishModal"/>

    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import draggable from "vuedraggable";
import ColorButton from "@/Components/Canvas2/ColorButton";
import CanvasTopCurve from "@/Others/Canvas2/CanvasTopCurve";
import JourneyCard from "@/Components/Canvas2/JourneyCard";
import FileUploaderModal from "@/Components/Canvas2/ActivityFileUploaderModal";
import InPlaceHtmlEditor from "@/Components/Common/InPlaceHtmlEditor";
import SleekFileUploader from "@/Components/Common/SleekFileUploader";
import PublishCanvasModal from "@/Components/Canvas2/PublishCanvasModal.vue";

export default {
    name: "StudentCanvasStage",
    components: {
        PublishCanvasModal,
        SleekFileUploader,
        InPlaceHtmlEditor, FileUploaderModal, JourneyCard, CanvasTopCurve, ColorButton, draggable},
    mixins: [utils, uploads],
    props: ['stage'],

    data(){
        return {

            upload: {
                show: false,
                data: null,
            },

            publish_modal: {
                enabled: false,
            }

        };
    },

    computed: {

        ...mapGetters('canvas2', [
            'canvas2_is_ready',
            'getAllCanvasActivityUploadsByStage',
            'getCanvasStageCover',
            'getCanvasDeliverable',
            'published_canvas_stages',
        ]),

        stage_is_published(){
            return this.published_canvas_stages.indexOf( this.stage.slug ) >= 0;
        },

        canvas_uploads: {
            get(){
                return this.getAllCanvasActivityUploadsByStage(this.stage.slug ) ?? [];
            },
            async set(uploads){
                await this.syncUploadsOnCanvas({stage: this.stage.slug, uploads});
            },
        },

        // TODO: Test updating through computed get/set methods to simplify process.

        cover(){
            return this.getCanvasStageCover(this.stage.slug);
        },

        deliverable(){
            return this.getCanvasDeliverable(this.stage.slug);
        },

        cover_background(){
            const url = this.uploads.image(this.cover?.image?.url, 1600);
            return `linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.25) 100%), url(${url}) no-repeat center / cover`;
        },

        editor_styles(){
            if( this.cover.text && this.cover.text.length > 60 ){
                return {'font-size': Math.max( 4 / (this.cover.text.length / 75), 2 ) + 'rem'};
            }
            return {};
        },

        deliverable_background(){
            const url = this.uploads.image(this.deliverable?.file?.preview_url, 1400);
            return `url(${url})`;
        },

    },

    methods: {

        ...mapActions('canvas2', [
            'syncUploadsOnCanvas',
            'syncUploadsOnCanvas',
            'addActivityUploadOnCanvas',
            'removeActivityUploadOnCanvas',
            'setCanvasStageCover',
            'setCanvasDeliverable',
            'publishCanvasStage',
            'unPublishCanvasStage',
        ]),

        showUpload(){
            this.upload.show = true;
        },

        hideUpload(){
            this.upload.show = false;
        },

        uploaded(){
            const uploaded = this.upload.data;
            this.addActivityUploadOnCanvas({
                stage: this.stage.slug,
                activity_id: uploaded.activity_id,
                file: uploaded.file,
                options: {width: 1},
            });
            this.hideUpload();
        },

        async removeUpload(upload){
            await this.syncUploadsOnCanvas({stage: this.stage.slug, uploads: this.uploads[ stage.slug ]});
        },

        coverImageUploaded(image){
            this.setCanvasStageCover({stage: this.stage, image});
        },

        coverTextUpdated(text){
            this.setCanvasStageCover({stage: this.stage, text});
        },

        goToActivities(){
            this.$inertia.visit( this.route('student.canvas2.activities', {
                uuid: this.$page.props.uuid,
                stage: this.stage.slug,
                ...this.global_url_params
            }));
        },


        publish(){
            this.publishCanvasStage(this.stage);
            this.showPublishModal();
        },

        unPublish(){
            if( ! confirm('Are you sure to unpublish this stage?') ) return;
            this.unPublishCanvasStage(this.stage);
        },

        showPublishModal(){
            this.publish_modal.enabled = true;
        },

        closePublishModal(){
            this.publish_modal.enabled = false;
        },

    }
}
</script>

<style lang="scss" scoped>
.canvas-stage{

    .mission{
        background: rgba(black, .3) url("https://images.unsplash.com/photo-1617117206620-b01f2919ff86?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80");
        background: linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.25) 100%), url("https://images.unsplash.com/photo-1617117206620-b01f2919ff86?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80") no-repeat center / cover;
        padding: 7rem 0;
        min-height: 600px;

        @media (max-width: 650px) {
            min-height: auto;
            padding: 3rem 0;
        }


        .text{
            font-size: 4rem;
            color: white;
            margin-bottom: 5rem;
            margin-left: auto;
            margin-right: auto;
            max-width: 900px;
            font-weight: $font-weight-bold;
            @media (max-width: 768px) {
                margin-bottom: 0;
                font-size: 2.5rem;

                @media (max-width: 650px) {
                    font-size: 1.3rem;
                }
            }
        }

        .image{
            text-align: center;
            color: darken(white, 10%);
            display: flex;
            flex-direction: column;
            max-width: 280px;
            margin: 0 auto 6rem;
            cursor: pointer;
            border-radius: .3rem;
            padding: 1rem;

            //&:hover{
            //    background: rgba(black, .3);
            //}

            .icon{
                font-size: 3rem;
            }
            @media (max-width: 650px) {
                margin: 0 auto 1rem;
                font-size: 14px;
            }
        }
    }
}

.journey{
    position: relative;
    padding-top: 5.5%;
    padding-bottom: 5rem;
    line-height: 1.2;

    .stage-top-curve{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 100%;

        .icon{
            position: absolute;
            top: 0;
            right: 10%;
            transform: translateY(-50%);

            img{
                width: 10rem;
                height: auto;
                @media (max-width: 650px) {
                    width: 5rem;
                }
            }
        }
    }

    .heading{
        font-size: 4rem;
        text-transform: uppercase;
        font-weight: $font-weight-bold;
        text-align: center;
        margin: 3rem 0 4rem;
        color: white;

        @media (max-width: 768px) {
            font-size: 2.25rem;
            margin: 0rem 0 4rem;

            @media (max-width: 650px) {
                font-size: 1.8rem;
                margin-top: 32px;

                @media (max-width: 400px) {
                    font-size: 1.2rem;
                }
            }
        }
    }
}

.deliverable{
    background: white no-repeat center / cover;
    border-radius: .4rem;
    padding: 3rem;
    box-shadow: rgba(black, 0.1) 0 0 15px;
    display: flex;
    align-items: center;
    @media (max-width: 1420px) {
        flex-direction: column;
        gap: 20px;

        @media (max-width: 768px) {
            padding: 2rem;
        }
    }
}

.deliverable-text{
    position: relative;
    color: white;
    font-size: 2.6rem;
    font-weight: $font-weight-bolder;
    padding: 3rem;
    margin-left: -6rem;
    width: 70%;
    min-height: 30rem;
    border-radius: .4rem;

    @media (max-width: 1420px) {
        width: 100%;
        margin-left: 0;
        margin-top: -6rem;
        min-height: auto;

        @media (max-width: 991px) {
            font-size: 2rem;

            @media (max-width: 650px) {
                font-size: 1.2rem;
                padding: 1rem;
                margin-top: -5rem;

                @media (max-width: 400px) {
                    font-size: 0.8rem;
                }
            }
        }
    }

    .text-area{

        &:before{
            content: '"';
            // position: absolute;
        }

        &:after{
            content: '"';
            // position: absolute;
        }
    }
}

.deliverable-image{
    font-size: 3rem;
    color: darken($light, 10%);
    text-align: center;
    margin: auto;

    .label{
        font-size: 1rem;
        @media (max-width: 650px) {
            font-size: 14px;
        }
    }
}

$gap: 2rem;

.journey-cards{
    margin-left: -$gap / 2;
    margin-right: -$gap / 2;
    margin-top: $gap;
    display: flex;
    flex-wrap: wrap;

    @media (max-width: 650px) {
        margin-left: 0;
        margin-right: 0;
    }

    .item{
        padding-left: $gap / 2;
        padding-right: $gap / 2;
        @media (max-width: 650px) {
            padding-left: 0;
            padding-right: 0;
        }
        flex: 0 0 100%;
        width: 100%;
        margin-bottom: $gap;

        &.w-1{
            flex: 0 0 33.3333333%;
            width: 33.3333333%;
        }

        &.w-2{
            flex: 0 0 66.666666%;
            width: 66.666666%;
        }

        &.w-3{
            flex: 0 0 100%;
            width: 100%;
        }
    }

    @media (min-width: 650px) and (max-width: 1199px){
        .item{

            &.w-1{
                flex: 0 0 50%;
                width: 50%;
            }

            &.w-2{
                flex: 0 0 100%;
                width: 100%;
            }

            &.w-3{
                flex: 0 0 100%;
                width: 100%;
            }
        }
    }

    @media (max-width: 650px) {
        .item {
            &.w-1 {
                flex: 0 0 100%;
                width: 100%;
            }
            &.w-2{
                flex: 0 0 100%;
                width: 100%;
            }

            &.w-3{
                flex: 0 0 100%;
                width: 100%;
            }
        }
    }
}


.canvas-stages{
    position: relative;

    .canvas-stage{
        &:last-child{
            .journey{
                padding-bottom: 10%;
            }
        }
    }
}

.stage-bottom-curve{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.actions{
    padding: .1rem 1rem;
    text-align: center;
    background: rgba(255,255,255,0.1);
    box-shadow: rgba(black, 0.1) 0 0 15px;
    border-radius: .3rem;

    @media (max-width: 991px) {
        width: fit-content;
        margin: 0 auto;
    }

    .action-row {
        display: grid;
        gap: 10px;
        grid-template-columns: auto auto auto;

        @media (max-width: 991px) {
            grid-template-columns: auto;
            gap: 0;
        }
        .action-col{
            margin: 8px 0;
            button {
                border-right: darken($light, 10%) solid 1px;
                width: 100%;
                @media (max-width: 991px) {
                    width: 50%;
                    min-width: 300px;
                    @media (max-width: 400px) {
                        min-width: 210px;
                    }
                }
            }
        }
    }
}

</style>
